module.exports = __webpack_public_path__ + "img/sla.85f712a1.jpg";